import { useQueryClient } from '@tanstack/react-query';
import { Outlet, useNavigate } from 'react-router-dom';
import { useLiveUpdates } from '../../hooks/useLiveUpdates';
import { t } from '../../i18n';
import { authApi } from '../../services/api';
import { toast, useAuthStore, useViewModeStore } from '../../store';
import { ToastContainer } from '../ui/Toast';
import { Header } from './Header';
import { Sidebar } from './Sidebar';

export function Layout() {
  const user = useAuthStore((s) => s.user);
  const setUser = useAuthStore((s) => s.setUser);
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const liveStatus = useLiveUpdates(!!user);
  const tiles = useViewModeStore((s) => s.viewMode === 'tiles');

  const logout = async () => {
    try {
      await authApi.logout();
    } catch {
      // Clear the local session even if the server is unreachable
    }
    setUser(null);
    queryClient.clear();
    navigate('/login', { replace: true });
    toast.info(t('Boli ste odhlásení'));
  };

  return (
    <div className="min-h-screen bg-secondary-50">
      <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:left-2 focus:top-2 focus:z-50 focus:rounded focus:bg-white focus:p-2">
        {t('Preskočiť na obsah')}
      </a>
      {!tiles && <Sidebar />}
      <div className={tiles ? undefined : 'lg:pl-64'}>
        <Header liveStatus={liveStatus} onLogout={logout} />
        <main id="main" className="mx-auto max-w-7xl p-4 lg:p-6">
          <Outlet />
        </main>
      </div>
      <ToastContainer />
    </div>
  );
}
